
import * as type from './types';

export function renameMyWorksFiles(data) {
    return {
        type: type.RENAME_MY_WORKS_ALBUM_REQUESTED,
        data: data,
    }
};